// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M13.3327 6.66663V4.33329C13.3327 3.39987 13.3327 2.93316 13.151 2.57664C12.9912 2.26304 12.7363 2.00807 12.4227 1.84828C12.0661 1.66663 11.5994 1.66663 10.666 1.66663H4.33268C3.39926 1.66663 2.93255 1.66663 2.57603 1.84828C2.26243 2.00807 2.00746 2.26304 1.84767 2.57664C1.66602 2.93316 1.66602 3.39987 1.66602 4.33329V10.6666C1.66602 11.6 1.66602 12.0668 1.84767 12.4233C2.00746 12.7369 2.26243 12.9918 2.57603 13.1516C2.93255 13.3333 3.39926 13.3333 4.33268 13.3333H6.66602M9.99935 12.5L11.666 14.1666L15.416 10.4166M9.33268 18.3333H15.666C16.5994 18.3333 17.0661 18.3333 17.4227 18.1516C17.7363 17.9918 17.9912 17.7369 18.151 17.4233C18.3327 17.0668 18.3327 16.6 18.3327 15.6666V9.33329C18.3327 8.39987 18.3327 7.93316 18.151 7.57664C17.9912 7.26304 17.7363 7.00807 17.4227 6.84828C17.0661 6.66663 16.5994 6.66663 15.666 6.66663H9.33268C8.39926 6.66663 7.93255 6.66663 7.57603 6.84828C7.26243 7.00807 7.00746 7.26304 6.84767 7.57664C6.66602 7.93316 6.66602 8.39987 6.66602 9.33329V15.6666C6.66602 16.6 6.66602 17.0668 6.84767 17.4233C7.00746 17.7369 7.26243 17.9918 7.57603 18.1516C7.93255 18.3333 8.39926 18.3333 9.33268 18.3333Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconDoubleSquareCheck = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconDoubleSquareCheck;
